export class PackingEC {
  id:number;
  tipo:number;
  usuariocamara:number;
  usuarioempaque:number;
  pesoporcaja:number;
  numerocajas:number;
  pesocajas:number;
  pesosaldo:number;
  pesototal:number;
  aprobado:number;
  estado:number;
  linea:number;

  constructor(id,tipo,usuariocamara,usuarioempaque,pesoporcaja,numerocajas,pesocajas,pesosaldo,pesototal,aprobado,estado,linea){
    this.id = id;
    this.tipo = tipo;
    this.usuariocamara = usuariocamara;
    this.usuarioempaque = usuarioempaque;
    this.pesoporcaja = pesoporcaja;
    this.numerocajas= numerocajas;
    this.pesocajas = pesocajas;
    this.pesosaldo = pesosaldo;
    this.pesototal = pesototal;
    this.aprobado = aprobado;
    this.estado = estado;
    this.linea = linea;
  }

/**
 * Crea el formato JSON para el envio a través de HTTP
 * @return JSON a enviar.
 */
  public getJson(){
    return `{
      "data":{
        "type": "packings",
        "id": "${this.id}",
        "attributes": {
          "id":"${this.id}",
          "packing_type_id":"${this.tipo}",
          "user_id":"${this.usuarioempaque}",
          "box_kg":"${this.pesoporcaja}",
          "amount_box":"${this.numerocajas}",
          "kg":"${this.pesocajas}",
          "residue_kg":"${this.pesosaldo}",
          "total":"${this.pesototal}",
          "is_approve":"${this.aprobado}",
          "packing_status_id":"${this.estado}",
          "line":"${this.linea}"
        }
      }
    }`;
  }
  /**
   * Crea el formato JSON para el envio a través de HTTP
   * @return JSON a enviar.
   */
    public getJson2(){
      return `{
        "data":{
          "type": "packings",
          "id": "${this.id}",
          "attributes": {
            "id":"${this.id}",
            "packing_status_id":"${this.estado}"
          }
        }
      }`;
    }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/model/PackingEC.ts